//
//
//
//
//
//
//
//
//
//

import cacheList from './api/whiteList'
import { mapGetters } from 'vuex'
// import bus from './lib/bus'
// import vconsole from 'vconsole'
// eslint-disable-next-line new-cap
// new vconsole()
export default {
  name: 'App',

  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['visitedList']),
    whiteList() {
      return [...cacheList, ...this.visitedList].join(',')
    }
  },
  watch: {
    '$route'(to, from) {
      setTimeout(() => {
        window.scroll(0, 0)
      }, 10)
      return to
    }
  },

  mounted() {
    // bus.$root.$on('socket', evt => {
    //   this.socket(evt)
    // })
  },
  methods: {
    socket(evt) {
      let data
      if (typeof evt === 'string') {
        data = JSON.parse(evt)
      } else {
        data = evt
      }
      this.$pushMsg.show({
        ...data,
        callBack({ data }) {
          if (data.jump) {
            location.assign(data.jump)
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue